// navigator.vibrate where it exists (Android). iOS Safari has none, so the
// motion carries the feel on its own and meaning never depends on a buzz
// (ux/04 Haptics). Patterns live in lib/constants.ts HAPTICS. Settings'
// Vibration switch (prefs.haptics) silences every one of them.
import { getPrefs } from './prefsStore'

export function haptic(pattern: number | readonly number[]): void {
  if (!getPrefs().haptics) return
  try {
    if (typeof navigator !== 'undefined' && 'vibrate' in navigator) navigator.vibrate(pattern as number | number[])
  } catch { /* some browsers throw outside a user gesture */ }
}
